import buildHeaders from '../../../../utils/api/fetchHeaders';

export const CITATION_REPORT_PIECES_URL = 'https://qa-chat-44330291471.us-central1.run.app/get-report-pieces';

async function parseResponseBody(response) {
    const text = await response.text();
    if (!text) {
        return null;
    }

    try {
        return JSON.parse(text);
    } catch (_) {
        return text;
    }
}

function buildErrorMessage(payload) {
    if (typeof payload === 'string' && payload.trim()) {
        return payload;
    }

    return payload?.error?.message || payload?.message || 'Failed to load citation report pieces';
}

export async function fetchCitationReportPieces(payload) {
    const response = await fetch(CITATION_REPORT_PIECES_URL, {
        method: 'POST',
        headers: buildHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(payload),
    });

    const responsePayload = await parseResponseBody(response);

    if (!response.ok) {
        throw new Error(buildErrorMessage(responsePayload));
    }

    return responsePayload;
}

